<template>
<div>
  <div class="header-width divcss5">
    <aboutbanner></aboutbanner>
      </div>
    <!-- <div class="  div-img-top1 body-width divcss5 "  >
    <div class="  font_zh  ">{{$t("about.aboutus")}}</div>
    <div class="  font_en font_en_top ">ABOUT US</div>
    </div> -->
        <!-- <div class=" row body-width divcss5">
        <aboutwe></aboutwe>
     </div> -->

    <!-- <div class="div-img-top1 body-width divcss5 "  >
      <div class="font_zh">{{$t("about.certifications")}}</div>
      <div class="font_en font_en_top ">CERTIFICATE</div>
    </div> -->
  <!-- <div class=" row body-width divcss5">
        <aboutcertificate></aboutcertificate>
     </div> -->
      <div class="row body-width divcss5" >
      <div class="img1class">
        <img src="../../../assets/images/zongce/01.jpg"/>
      </div>
      <div class="img1class">
        <img src="../../../assets/images/zongce/02.jpg"/>
      </div>
</div>
  </div>
</template>

<script>
import aboutbanner from "@/components/contentcoms/aboutcontentcoms/aboutbanner";
import aboutwe from "@/components/contentcoms/aboutcontentcoms/aboutwe";
import aboutcertificate from "@/components/contentcoms/aboutcontentcoms/aboutcertificate";
  export default {
    name: "aboutcontent",

    components: {
    aboutbanner,
    aboutwe,
    aboutcertificate
    }
}
  
</script>

<style scoped>

.div-top{
  margin-top: 50px;
  margin-bottom: 40px;
  background-image: url(../../../assets/images/product5.png) ;
  background-repeat: no-repeat ; 
  background-position:center ;
}

.img1class{
    margin-top: 10px;
     margin-bottom: 40px;
     color: #b6b6b6;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/aboutcontentcoms/aboutcontent.vue